import $ from "jquery";
window.$ = window.jQuery = $;
import 'jquery-mask-plugin';

$(document).ready(function () {
    $('.js_phone_mask').each((i,el) => {
        $(el).mask("+380 (99) 999-99-99")
    })
    const selectTools = {
        toggleSelect(btn) {
            btn.toggleClass('active')
        },

        closeSelect(btn) {
            if (btn) {
                btn.removeClass('active')
            } else {
                $('.js_global__select-btn.active').removeClass('active')
            }
        },

        setValue(btn) {
            const select = btn.closest('.js_global__select')
            const selectBtn = select.find('.js_global__select-btn')
            const callback = select.attr('data-callback')
            if (callback && window[callback]) {
                window[callback](btn)
            }
            selectBtn.find('span').text(btn.text().trim())
            btn.addClass('active')
            btn.siblings().removeClass('active')
            selectTools.closeSelect(selectBtn)
        }
    }

    $(document).on('click', '.js_global__select-btn', function () {
        selectTools.toggleSelect($(this))
    })

    $(document).on('click', function (e) {
        const target = $(e.target)

        if (!target.closest('.js_global__select').length) {
            selectTools.closeSelect()
        }
    })

    $(document).on('click', '.js_global__select-item', function () {
        selectTools.setValue($(this))
    })

    $(document).on('input', '.js_global__input', function() {
        if ($(this).val().length) {
            $(this).removeAttr('data-empty data-invalid')
        }
    })

    $(document).on('change', '.js_global__checkbox', function() {
        if ($(this).is(':checked')) {
            $(this).removeClass('error')
        }
    })
})
